/**
 * This is a map for API Portal redirects
 */
export const apiPortalRedirects: { [key: string]: string } = {
  // core wifi Specs
  '/api-portals/connected-living/core-wifi/specs/pods-activation':
    '/api-portals/connected-living/core-wifi/specs/pods-and-extenders-life-cycle',
  '/api-portals/connected-living/core-wifi/specs/extenders':
    '/api-portals/connected-living/core-wifi/specs/extenders-life-cycle-network-id',
};
